import * as React from "react";
import { Polyglot } from "../../../../polyglot";
import { Container } from "../../../Container";
import { FlagStore } from "../../../flux/Flag";
import { SearchProps } from "../SearchProps";
import { GenericSearch } from "./GenericSearch";
import { SearchActions } from "./Actions";
import { SearchFormStore } from "./Store";

type Props = SearchProps & { polyglot: Polyglot };
export class GenericSearchWidget extends React.Component<Props, any>
{
    private readonly searchFormActions = new SearchActions();

    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<any>, nextContext: any)
    {
        return false;
    }
    
    render()
    {
        return (
            <Container merge stores={[
                [this.props.searchFormStore, (store: SearchFormStore) => ({ searchParams: store.getState() })],
                [this.props.searchInProgressStore, (store: FlagStore) => ({ searchInProgress: store.isSet() })],
                this.props.searchErrorStore,
            ]}>
                <GenericSearch polyglot={this.props.polyglot}
                    onChange={f => this.searchFormActions.updateSearchParams(f.getValue(), this.props.searchFormStore.dispatchToken)}
                    onSearch={f => this.props.searchCommand.execute(f.getValue())}
                />
            </Container>
        );
    }    
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Search/GenericSearchWidget.tsx